import { EntityDescriptor } from '../business-logic';
import { dataChangesSchema } from '../schemas/dataChanges';

export const dataChangesEntity: EntityDescriptor = {
	dataChanges: {
		migrationStrategies: {
			1: function (oldDoc: any) {
				// migration to rxdb 12
				return oldDoc;
			},
			2: function (oldDoc) {
				oldDoc.checkedInLegs = oldDoc.checkedInLegs ?? [];
				return oldDoc;
			},
			3: function (oldDoc) {
				oldDoc.options = oldDoc.options ?? null;
				return oldDoc;
			},
			4: function (oldDoc) {
				oldDoc.isSynced = oldDoc.synced ?? true;
				return oldDoc;
			},
		},
		schema: dataChangesSchema,
	},
};
